import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import InvoiceStep from './step'
import Success from './success'
export default class Invoice extends Component {
    componentDidMount() {
        //this.props.history.push({ pathname: '/invoice/step1', state: { invoiceNumber: '222' } })
    }
    render() {
        return (
            <div>
                <Switch>
                    <Route path='/takeInvoice/step1' component={InvoiceStep} />
                    <Route path='/takeInvoice/success' component={Success} />
                    <Redirect to='/takeInvoice/step1' />
                </Switch>

            </div>
        )
    }
}
